var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.baseClass},_vm._l((_vm.totalSteps),function(step){return _c('div',{key:step,class:[`${_vm.baseClass}__step`, { [`${_vm.baseClass}__step--active`]: step === _vm.currentStep }]})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }